import { useLocation } from 'react-router'
import { CanvasSkeleton, ComposerSkeleton, TableSkeleton } from '~/core/ui/skeletons'

/**
 * What stands in while the Agent's providers or its chunk arrive, before any
 * screen can say what it looks like — so it is chosen by the address. Most of
 * the Agent is a list; home and a chat are a composer, a workflow a canvas.
 * The run history in Tasks mounts the same providers inside a padded pane.
 */
export function AgentSkeleton() {
  const { pathname } = useLocation()
  if (/\/agent\/(home|chat)(\/|$)/.test(pathname)) return <ComposerSkeleton />
  if (pathname.includes('/agent/w/')) return <CanvasSkeleton />
  return <TableSkeleton className={pathname.includes('/agent/') ? 'p-(--s-10)' : undefined} />
}
